import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import "./index.scss";
import { TimeInfo } from '../TimeInfoOrderDraft';
import { isRTL } from '../../../../services/userModel';
import { isDateOverdue } from '../../../../utils/order';
import IconButton from '../../IconButton';

export const DeliveryTimeDraft = ({
  deliveryInfo,
  pickupTime,
  pickupEta,
  dropOffEta,
  deliveryDatetime,
  actual_delivery_datetime,
  style
}) => {
  const rtl = isRTL();
  const { t } = useTranslation();

  const shouldDisplayDropOffOrDeliveryTime =
    !!(dropOffEta || actual_delivery_datetime);

  const warningDescription = dropOffEta
    ? t('draft.deliveryOverdueExtended', {
        estimatedTimeArrival: moment(dropOffEta).format('HH:mm'),
        committedTimeArrival: moment(deliveryDatetime).format('HH:mm')
      })
    : t('draft.deliveryOverdue', {
        date: moment(dropOffEta ?? deliveryDatetime).format('HH:mm')
      });

  return (
    <div className="delivery-time-draft" style={style}>

      {deliveryInfo && !actual_delivery_datetime ? (
        <TimeInfo {...deliveryInfo} />
      ) : (
        <>
          {!!(pickupTime || pickupEta) && (
            <>
              <TimeInfo
                label={t(
                  pickupTime
                    ? 'draft.pickedUp'
                    : 'draft.pickUp'
                )}
                value={moment(pickupTime || pickupEta).format('HH:mm')}
              />

              {shouldDisplayDropOffOrDeliveryTime && (
                <IconButton isIcon iconName={rtl ? 'paginationPrevious' : 'paginationNext'} />
              )}
            </>
          )}

          {shouldDisplayDropOffOrDeliveryTime && (
            <TimeInfo
              label={
                dropOffEta
                  ? t('draft.dropOff')
                  : t('draft.delivery')
              }
              value={moment(dropOffEta || actual_delivery_datetime).format(
                'HH:mm'
              )}
              isWarning={isDateOverdue(
                dropOffEta ?? actual_delivery_datetime,
                deliveryDatetime
              )}
              warningDescription={warningDescription}
            />
          )}
        </>
      )}

    </div>
  );
};